import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Martín',
  city: 'Rosario'
}, {
  name: 'Laura',
  city: 'Córdoba'
}, {
  name: 'Diego',
  city: 'Buenos Aires'
}, {
  name: 'Sofía',
  city: 'Mendoza'
}, {
  name: 'Javier',
  city: 'Mar del Plata'
}, {
  name: 'Camila',
  city: 'La Plata'
}, {
  name: 'Lucas',
  city: 'Tucumán'
}, {
  name: 'Valentina',
  city: 'Neuquén'
}, {
  name: 'Mateo',
  city: 'Santa Fe'
}, {
  name: 'Florencia',
  city: 'Salta'
}];
export function PurchasePopup() {
  const [currentPurchase, setCurrentPurchase] = useState<(typeof purchases)[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showRandomPurchase = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Show for 4 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showRandomPurchase, 5000);
    // Then every 12 seconds
    const interval = setInterval(showRandomPurchase, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-104">
      {isVisible && currentPurchase && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white border-l-4 border-bordo shadow-xl rounded-r-lg p-4 max-w-sm flex items-center gap-4" data-id="element-105">
          <div className="bg-crema p-2 rounded-full text-bordo" data-id="element-106">
            <ShoppingBag size={20} data-id="element-107" />
          </div>
          <div data-id="element-108">
            <p className="text-sm text-gray-800 font-medium" data-id="element-109">
              <span className="font-bold" data-id="element-110">{currentPurchase.name}</span> de{' '}
              {currentPurchase.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-111">
              acaba de comprar La Biblia de la Milanesa
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}